// extracted by mini-css-extract-plugin
export default {"about_client":"Client_about_client__kIeeV","domestic":"Client_domestic__mHbxJ"};